import { FileType, Notation } from '@alucio/aws-beacon-amplify/src/models';
import { PPZTransform } from '../../../index';

export enum PRESENTATION_CONTEXT {
    PUBLISHER = 'PUBLISHER',
    APP = 'APP',
}

export interface PresentationState {
    context: PRESENTATION_CONTEXT,
    lastUpdated: Date,
    content: PresentationContent,
}

export interface PresentationContent {
    JWT: string
    bucket: string
    docPath: string
    documentVersionId: string
    documentId: string
    groupId?: string
    customDeckId?: string
    contentType: FileType
    visiblePages: number[]
    state: PresentationContentState
    watermarkText?: string
    contentURL?: string
    pageData?: HtmlPageData
    notations?: Notation[]
    isContentCached?: boolean
}

export type PresentationContentWithNotations = PresentationContent & {
    notations?: Notation[]
}

export interface PresentationBroadcastContent extends Omit<PresentationContent, 'groupId' | 'state'> {
    groupId: string
    ppzCoords?: PPZTransform
    state: {
        page: number,
        step: number,
        totalSteps: number,
    }
}

export interface HtmlPageData {
    pages: HtmlPage[]
    mode?: 'classic' | 'spa'
    entryHtmlUrl?: string
}

export interface HtmlPage {
    number: number
    htmlUrl?: string
    htmlPageImage?: string
}

export interface PresentationContentState {
    documentVersionId?: string,
    groupId?: string,
    page?: number,
    step?: number,
    totalSteps?: number,
    pageData?: HtmlPageData,
    viewport?: PPZTransform
}
